import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function PermisosHeader({
  total,
  personalizados,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  personalizados: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Gestión de permisos"
      description={`${total} permisos (${personalizados} personalizados) · el catálogo se siembra desde el código; aquí editas metadatos, activas/desactivas y registras permisos nuevos.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo permiso
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
